import React, {useState, useCallback, useEffect, useContext} from 'react';
import DashboardMain_Orion from '../DashboardMain_Orion/DashboardMain_Orion';
import FilterSection_Orion from './FaultFirstPage_Orion/FilterSection_Orion';
// import '../Faultanalysis_Bus/FaultFirstPage_Bus/FaultFirstPageCustom_bus.css';
import '../Faultanalysis_Orion/FaultFirstPage_Orion/FaultFirstPageCustom_Orion.css';
import { decodeToken } from 'react-jwt';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_orion';
import KPISection_Orion from './FaultFirstPage_Orion/KPISection_Orion';
import DataBarSection_Orion from './FaultFirstPage_Orion/DataBarSection_Orion';
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import AppContext from '../../../store/AppContext';
import FaultSingleVinAnalysis_Orion from './FaultSingleVinAnalysis_Orion';
import FaultFirstGraph_Orion from './FaultFirstPage_Orion/FaultFirstGraph_Orion';
import FaultSecondGraph_Orion from './FaultFirstPage_Orion/FaultSecondGraph_Orion';

export default function FaultPage_Orion() {
    const tokenNew = JSON.parse(sessionStorage.user);
    let decodedToken = decodeToken(tokenNew.token);
    const city_name = decodedToken.city_name;
    const city_name_arr = city_name.split(",");
    const depo_name = decodedToken.depo_name;
    const depo_name_arr = depo_name.split(",");
    let sampleObj = (city_name !== "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE
  
    const [gloablfilter, setGloablfilter] = useState(sampleObj);
    const { isLoading, error, sendReq: fetchData } = useHttp();

    const app_ctx = useContext(AppContext);
    const log_data = (data) => {
    }

    useEffect(() => {
        fetchData({
          url: API_URL_MAIN + "auth/logging", body: {
            page_name: "faultanalysis_Orion"
    
          }
        }, log_data)
      }, []);

    const filterSubmited = useCallback((data) => {
        setGloablfilter(data);
    }, []);

    const onreset = (data) => {
        setGloablfilter(data);
    }

    const singleVinSelected = (vin) => {
        let vin_num = vin.split(",");
        setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
    }

    const pageChange = () => {
      setGloablfilter((prevdata) => {
        return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
      });
    }

    if (gloablfilter.pageSelected === 1) {
        return (
          <>
            <DashboardMain_Orion>
                <FilterSection_Orion onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset}/>
                <div className="container-fluid busdrpg1">
                    <KPISection_Orion gloablfilter={gloablfilter} />
                    <section className="graphs sec2Charts">
                        <DataBarSection_Orion singleVinSelected={singleVinSelected} gloablfilter={gloablfilter} />
                        <div className="row mt-4 equal-cols">
                          <FaultFirstGraph_Orion gloablfilter={gloablfilter} />
                          <FaultSecondGraph_Orion gloablfilter={gloablfilter} />
                        </div>
                    </section>
                </div>
            </DashboardMain_Orion>
          </>
        );
      } else {
        return (
          <FaultSingleVinAnalysis_Orion gloablfilter={gloablfilter} pageChange={pageChange} />
        );
      }
}
